<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" :title="(designation.sub_designation_id ? 'Edit' : 'New') + ' Designation'" size="lg" ok-title="Save Designation" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="designationModal" :ok-disabled="saving" :cancel-disabled="saving" :no-close-on-backdrop="true" scrollable>

            <div v-if="loading" class="text-center">
                <i class="fa fa-circle-o-notch fa-spin"></i> Loading
            </div>
            <template v-else>
                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.state_id }">State:</label>
                    <div class="col-md-8">

                        <select v-model="designation.state_id" class="form-control" :class="{'is-invalid': errors.state_id}">
                            <option :value="null">-- Select a State --</option>
                            <option v-for="state in state_list" :value="state.state_id">{{ state.state_name }} ({{ state.state_code }})</option>
                        </select>

                        <span v-if="errors.state_id" class="text-danger">
                            <span v-for="error in errors.state_id">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.designation_id }">Minority Cert:</label>
                    <div class="col-md-8">

                        <b-form-select v-model="designation.designation_id" :options="designationOptions" :class="{'is-invalid': errors.designation_id}"/>

                        <span v-if="errors.designation_id" class="text-danger">
                            <span v-for="error in errors.designation_id">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <template v-if="enableOther">
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"></label>
                        <div class="col-md-8">
                            <b-form-checkbox v-model="is_other_designation" :value="1" :unchecked-value="0" plain> Enter Other Designation</b-form-checkbox>

                            <span v-if="errors.is_other_designation" class="text-danger">
                                <span v-for="error in errors.is_other_designation">{{ error }}</span>
                            </span>
                        </div>
                    </div>

                    <div class="form-group row" v-if="is_other_designation == 1">
                        <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.other_designation_name }">Other Designation Name:</label>
                        <div class="col-md-8">

                            <b-form-input v-model="designation.other_designation_name" :class="{'is-invalid': errors.other_designation_name}" placeholder="Enter Other Designation Name" />

                            <span v-if="errors.other_designation_name" class="text-danger">
                                <span v-for="error in errors.other_designation_name">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                </template>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.certifying_agency }">Certifying Agency: <i class="fa fa-sm fa-asterisk text-danger"></i> 
                    </label>
                    <div class="col-md-8">

                        <b-form-textarea v-model="designation.certifying_agency" type="text" placeholder="Enter name of the certifying agency (city, DOT, federal agency, etc.) and the expiration date of your certification - or - self-certified" :class="{'is-invalid': errors.certifying_agency}" rows="2"></b-form-textarea>

                        <span v-if="errors.certifying_agency" class="text-danger">
                            <span v-for="error in errors.certifying_agency">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.file }">Copy of Certificate/Award Letter:</label>
                    <div class="col-md-8">
                        <b-form-file v-model="file" plain></b-form-file>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            subcontractorId: {
                type: Number,
                default: null,
            },

            enableOther: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                openModal: false,
                loading: true,
                saving: false,
                is_other_designation: 0,
                errors: {},
                file: null,
                designation_list: [],
                designation: {
                    state_id: null,
                    designation_id: null,
                },
            }
        },

        computed: {
            state_list() {
                return this.$store.state.state_list;
            },

            designationOptions(){
                //SEtup
                var options = [{value: null, text: '-- Select a Designation --'}];
                var keys = Object.keys(this.designation_list);

                //Loop and build
                for(var i = 0; i < keys.length; i++)
                {
                    //Append
                    options.push({value: keys[i], text: this.designation_list[keys[i]]});
                }

                //Send it
                return options;
            },
        },

        methods: {
            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the values
                this.designation = {};
                this.errors = {};
                this.file = null;
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Do it
               this.saveDesignation();
            },

            showModal(){
                //Show it
                this.openModal = true;
            },

            setModel(designation){
                //Set it
                this.designation = JSON.parse(JSON.stringify(designation));

                //Check it
                if(this.designation.other_designation_name)
                {
                    this.is_other_designation = 1;
                }
            },

            getFormResources(){
                //Loading indicator
                this.loading = true;

                //Get the resources
                this.$http
                    .get('subcontractors/designation')
                    .then(response => {
                        //Set it
                        this.designation_list = response.data.designations;

                        //Loading false
                        this.loading = false;
                    });
            },

            saveDesignation(){
                //Flag Helper
                this.saving = true;

                //Set the helper
                this.designation.enable_other = this.is_other_designation;

                //Send it
                this.$http
                .postWithFiles('subcontractors/designation/' + this.subcontractorId, this.designation, (this.file ? [this.file] : []))
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Designation Saved');

                    //Update the Store
                    this.$store.commit('updateDesignations', response.data);

                    //Close the modal
                    this.$refs.designationModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Set the height
            //this.$refs.designationModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

            //Get the resources
            this.getFormResources();
        }
    }
</script>